<template>
  <div :class="classes" v-loading.fullscreen.lock="loading" :element-loading-text="loadingText">
    <pt-page-title :title="currentTitle"></pt-page-title>
    <div class="tip">
      已选择委托单：<span>{{this.selectedOrder.length}}</span>
    </div>
    <!-- 批量操作内容 -->
    <component
      v-if="hasForm"
      ref="child"
      :billIds="this.selectedOrder.map(e=>e.id)"
      :isLot="true"
      :status="action"
      :is="action"
      @updateAllSize="updateAllSize"
      :loadingText="loadingText"
    ></component>
    <pt-distribute-task v-if="action === 'BILL_ASSIGN'" isBatch ref="assignTask"></pt-distribute-task>
    <pt-sub-title :title="subTitle">
      <el-button type="text" slot="line" style="margin-left:10px;" @click="showDialig = true">点击查看已勾选数据</el-button>
    </pt-sub-title>
    <!-- 列表 -->
    <ptTrustDeedList
      :isLot="true"
      ref="table"
      :billStatusEnum="targetData.otherParams.billStatusEnum"
      @selection-change="updateSelectData"
      @getAllSize="(val)=>allSize = val"
    ></ptTrustDeedList>
    <div class="button-div" >
      <el-button type="primary" @click="save">提交</el-button>
      <el-button type="primary" plain @click="cancel">取消</el-button>
      
    </div>

    <!-- 查看已勾选数据 -->
    <selected-data-dialog :dialogVisible="showDialig" :tableData="selectedOrder" @updateVisible="(val)=>showDialig = val"></selected-data-dialog>

  </div>
</template>

<script>
  import BILL_CHECKED from 'cps/trust-deed/order-status/form/BILL_CHECKED'
  import BILL_RECEIVE from 'cps/trust-deed/order-status/form/BILL_RECEIVE'
  import BILL_DELAY from 'cps/trust-deed/BILL_DELAY'
  // import BILL_ASSIGN from 'cps/trust-deed/order-status/form/BILL_ASSIGN'
  import ptDistributeTask from "../pt-distribute-task"
  import selectedDataDialog from './selected-data-dialog'
  import ptTrustDeedList from 'cps/trust-deed/pt-trust-deed-list/index'
  import { LABStatus} from 'cps/trust-deed/pt-lot-operate-choice-dialog/choice'
  import { nextTrust } from 'cps/trust-deed/order-status/status'
// 组件class前缀
const prefixCls = 'pt-bill-lot-operate'

export default {
  name: 'pt-bill-lot-operate',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    subTitle () {
      return '已勾选委托单（' + this.selectedOrder.length + '/' + this.allSize + '）'
    },
    targetData () {
      console.log('this.$route.params.status', this.$route.params.status)
      return LABStatus.find(e=>e.name === this.$route.params.status)
    },
    action(){
      return this.targetData.action
    },
    currentTitle () {
      if (this.action === 'BILL_RECEIVE') {
        return '批量样品接收'
      }
      if (this.action === 'BILL_CHECKED') {
        return '批量审核委托单'
      }
      if (this.action === 'BILL_ASSIGN') {
        return '批量分配委托单'
      }
      if (this.action === 'BILL_DELAY') {
        return '批量延期交付'
      }
      return ''
    },
    hasForm () {
      return this.action === 'BILL_CHECKED'|| this.action === 'BILL_RECEIVE' || this.action === 'BILL_DELAY'
    },
    isAssignTask () {
      return this.action === 'BILL_ASSIGN'
    },
  },
  props: {
  },
  data () {
    return {
      allSize: '',
      loading: false,
      loadingText: '正在处理中，请稍后',
      selectedOrder: [],
      showDialig:false
    }
  },

  components: {
    BILL_CHECKED,
    BILL_RECEIVE,
    BILL_DELAY,
    selectedDataDialog,
    ptTrustDeedList,
    ptDistributeTask
    // LAB_DNA_READY,
    // INDEX_BUILD,
    // DATA_ANALYSISED,
    // REPORT_CHECKED_1ST,
    // LAB_DNA_TESTED,
    // DATA_RETURN,
    // CHIP_SLOT,
    // SAMPLE_RETURNED,
    // AMPLIFICATION,
    // DYE_AND_SCAN,
    // LIBRARY_QUALITY_INSPECT
  },
  methods: {
    cancel () {
      history.go(-1)
    },
    save(){
      if(!this.selectedOrder.length){
        this.$message.warning('请先勾选委托单')
        return
      }
      if (this.hasForm) {
        this.$refs.child.formValidata().then(() => {

          this.loading = true
          // 对于延迟操作，我们需要特殊处理
          if (this.action === 'BILL_DELAY') {
            let form = this.$refs.child.form
            let data = {
              ids: this.selectedOrder.map(e => e.id),
              delayDate: form.delayDate,
              delayReason: form.delayReason,
              comment: form.comment
            }

            this.$store.dispatch('handleDelay', data).then(res => {
              this.$message.success('操作成功')
              // 重新加载表格数据以显示"已延期"状态
              this.$refs.table.reload()
              this.selectedOrder = []
              // 重置表单
              if (this.$refs.child && typeof this.$refs.child.resetForm === 'function') {
                this.$refs.child.resetForm()
              }
            }).catch(err => {
              this.$message.error(err.message || err)
            }).finally(() => {
              this.loading = false
            })
          } else {
            this.$refs.child.next().then(response => {
              this.$refs.table.reload()
              this.selectedOrder = []
            }).catch(err => {
              this.$message.error(err.message || err)
            }).finally(() => {
              this.loading = false
            })
          }
        })
      } else {
        if (this.isAssignTask) {
          this.$refs.assignTask.formValidata().then(() => {
            this.submit()
          })
        }else {
          this.submit()
        }
        
      }
    },
    submit () {
      let data = {
        action: this.action,
        billStatusDetail: {
          action: this.action,
        },
        billIds: this.selectedOrder.map(e => e.id)
      }
      if (this.isAssignTask) {
        let form = this.$refs.assignTask.form
        let currentTester = this.$refs.assignTask.currentTester
        data.billStatusDetail.productionTaskDetail = {
          startTime: form.startTime,
          endTime: form.endTime,
          comment: form.comment,
          labTester: {
            name: currentTester.label,
            organizationUserId: currentTester.value,
            signatureImageUrl: currentTester.signatureImageUrl
          }
        }
      }
      nextTrust.call(this, data, true).then(res => {
        this.$refs.table.reload()
        this.selectedOrder = []
        this.$refs.assignTask.form={}
      }).catch(err => {
        this.$message.error(err.message || err)
      }).finally(() => {
        this.loading = false
      })
    },
    updateSelectData(data){
      this.selectedOrder = data
    }
  },
  created () {
   
  }
}
</script>


<style lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
@import "~less/var.less";
.pt-bill-lot-operate {
  .tip{
    font-size:18px;
    margin:20px 0;
    span{
      font-size:20px;
      font-weight:bold;
      color: @mainColor;
    }
  }
  .received-title {
    //本样式在子组件中使用
    font-size: 1rem;
    margin-top: 0.5rem;
  }
  .el-upload-list {
    max-width: 800px;
  }
  .statistics {
    font-size: 22px;
    font-weight: normal;
    span.num {
      font-size: 30px;
      font-weight: bold;
      color: #0a4a94;
    }
  }
  .info-tip {
    //本样式在子组件中使用
    color: red;
    font-size: 12px;
    padding: 10px 0;
  }
  .operate-buttons {
    margin: 40px 0 30px;
  }
  .selected {
    .checkboxList {
      margin-top: 20px;
      position: relative;
    }
  }
}
</style>
